import Tag from 'antd/es/tag'
import { useTranslation } from 'react-i18next'

interface IdeaDirectionTagProps {
  direction: 'Long' | 'Short'
}

export const IdeaDirectionTag: React.FC<IdeaDirectionTagProps> = ({
  direction,
}) => {
  const { t } = useTranslation()
  if (direction === 'Long') {
    return (
      <Tag color={'green'} style={{ color: 'green', borderRadius: 4 }}>
        {t('idea_list.idea_table.direction.long')}
      </Tag>
    )
  }
  if (direction === 'Short') {
    return (
      <Tag color={'red'} style={{ color: 'red', borderRadius: 4 }}>
        {t('idea_list.idea_table.direction.short')}
      </Tag>
    )
  }

  return direction
}
